const simpul_validate = require("simpul-validate");
const dictionary = require("./dictionary.index");

// DOMPurifyOptions: allows strict control over tags supported by rich_text_story.
//
// RE: Handling Rich Text input ("rich_text_story")
//
// 1. Using ignoreIsSanitized flag since input gets sanitized
//    on onSubmit client-side and on validationMiddleware
//    server-side... Checking for dirty strings in rich_text_story
//    is counter-productive since the string can be potentially
//    very long... The only ideal solution is to be able to
//    parse for the dirty strings, and highlight them to the user
//    for changing (like in GitHub)... As well, it's not a value
//    that needs to be correct on onSubmit, since a user can easily
//    post the story, read the sanitized version, spot the difference,
//    delete the story and post it again, unlike something like
//    username, which needs to absolutely be correct before submission.
//
// 2. From experience: can't use stripHtml because the tags need to be checked
//    for sanitization. It may well be the case that someone could manually
//    submit an html string that can run scripts on other user clients through
//    dangerouslySetInnerHTML.

const validate = simpul_validate(dictionary.configs, {
  async: true,
  DOMPurifyOptions: {
    ALLOWED_TAGS: [
      "p",
      "br",
      "span",
      "strong",
      "em",
      "u",
      "s",
      "blockquote",
      "ol",
      "ul",
      "li",
    ],
    ALLOWED_ATTR: ["class"],
  },
});

module.exports = validate;
